import { render, staticRenderFns } from "./dataScreening.vue?vue&type=template&id=e35d4232&scoped=true"
import script from "./dataScreening.vue?vue&type=script&lang=js"
export * from "./dataScreening.vue?vue&type=script&lang=js"
import style0 from "./dataScreening.vue?vue&type=style&index=0&id=e35d4232&prod&lang=scss"
import style1 from "./dataScreening.vue?vue&type=style&index=1&id=e35d4232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35d4232",
  null
  
)

export default component.exports